import {
  setCreditScoreResult,
  setHomePath,
  setNextDate,
  fetchApplicationDataV3,
  verifyPayroll,
  setTimer,
  startTimer,
  setResponseCodeReject,
  stopTimer,
  setSelectedOffering,
  inquiryLoanPayment,
  ekycCheckingStatusV3,
  setIsFlowSuplesiActive,
  loading,
  checkValidatePhotoStatus,
  fetchLoanProduct,
  fetchDocRiplay,
  statusPayment
} from 'store/actions';
import {
  clearTimer,
  resetLocalStorageForPaidOffSuplesi
} from 'helpers/Utility';

const handleFetchApplicationDataV3 = (dispatch, auth, data, history) => {
  dispatch(
    fetchApplicationDataV3(
      {
        phoneNo: auth.phoneNo,
        token: auth.token,
        applicationId: data.applicationIdSuplesi,
        prevAppId: data.applicationId
      },
      {
        action: () => {
          if (data.applicationStatusSuplesi.cmCode == 'APP_CREATED') {
            dispatch(
              fetchDocRiplay(
                {
                  token: auth.token,
                  applicationId: data.applicationIdSuplesi
                },
                {
                  action: () => history.push('/new-loan'),
                  docType: 'DTRP'
                }
              )
            );
          } else {
            history.push('/form-fill');
          }
        }
      }
    )
  );
};

const handleVerifyPayrollData = (
  dispatch,
  auth,
  data,
  history,
  isFlowSuplesiActive
) => {
  if (!localStorage.getItem('verifyPayrollData')) {
    dispatch(
      verifyPayroll(
        {
          token: auth.token,
          schemeCode: data.schemeCode,
          subCode: data?.subCode || ''
        },
        () => handleFetchApplicationDataV3(dispatch, auth, data, history),
        { isFlowSuplesiActive: isFlowSuplesiActive }
      )
    );
  } else {
    handleFetchApplicationDataV3(dispatch, auth, data, history);
  }
};

const handleCreditScoreSubmission = (dispatch, data, params, history) => {
  localStorage.setItem('setCS', 1);

  dispatch(
    setTimer({
      minutes: data.timeLeftForScoreCompletion,
      seconds: 0
    })
  );

  dispatch(startTimer());

  if (params && !params.isCounting) {
    dispatch(setCreditScoreResult(''));
    dispatch(startTimer());
  }

  history.push('/suplesi/cr-score');
};

const handleCreditScoreReject = (dispatch, data, params, history) => {
  dispatch(setNextDate(data?.rejectionDetails?.nextEligibilityDate || ''));
  dispatch(setResponseCodeReject(data?.rejectionDetails?.responseCode));
  dispatch(setCreditScoreResult('rejected'));
  localStorage.removeItem('documentDetails');
  dispatch(setTimer({ minutes: '', seconds: '' }));
  dispatch(stopTimer());
  if (data?.rejectionDetails?.nextEligibilityDate) {
    params?.actionRejected?.(data?.rejectionDetails?.nextEligibilityDate);
  } else {
    history.push('/suplesi/cr-score');
  }
};

const handleCreditScoreApprove = (dispatch, data, history) => {
  const details = data.approvalDetails || {};
  const {
    alternative,
    plafond1,
    plafond2,
    tenor1: tenure1,
    tenor2: tenure2,
    approvalAmount,
    serviceFeePercentage,
    serviceFeeAmount,
    plafondWithService
  } = details;

  const installment1 = details.oneMonthPayDetails?.oneMonthPayForPlafond1;
  const installment2 = details.monthlyPayDetails?.find(
    i => i.loanTenor === Number(tenure2)
  )?.monthlyPayment;

  //done approve scoring
  if (approvalAmount > 0) {
    history.push('/disburse-acc');
    dispatch(setHomePath('/continue-disburse'));
    return;
  }

  //alternative
  if ((plafond1 > 0 && plafond2 > 0 && plafond2 > plafond1) || alternative) {
    dispatch(
      setSelectedOffering({
        plafond: plafond2,
        tenure: tenure2,
        installment: installment2,
        serviceFeePercentage: serviceFeePercentage
      })
    );
    dispatch(
      setSelectedOffering({
        plafond: plafond1,
        tenure: tenure1,
        installment: installment1,
        serviceFeePercentage: serviceFeePercentage
      })
    );
    dispatch(setCreditScoreResult('offering'));
    clearTimer(dispatch);
    history.push('/suplesi/approve');
    return;
  }

  //default
  const selected =
    plafond1 > 0
      ? {
          plafond: plafond1,
          tenure: tenure1,
          serviceFeePercentage: serviceFeePercentage,
          serviceFeeAmount: serviceFeeAmount,
          plafondWithService: plafondWithService
        }
      : {
          plafond: plafond2,
          tenure: tenure2,
          serviceFeePercentage: serviceFeePercentage,
          serviceFeeAmount: serviceFeeAmount,
          plafondWithService: plafondWithService
        };

  dispatch(setSelectedOffering(selected));
  dispatch(setCreditScoreResult('approved'));
  clearTimer(dispatch);

  history.push('/suplesi/approve');
};

/**
 * to handle application status
 * @param {*} dispatch
 * @param {*} appStatus
 * @param {*} data
 * @param {*} auth
 * @param {*} params
 * @returns
 */
export const handleApplicationStatusV3 = ({
  dispatch,
  appStatusSuplesi,
  data,
  auth,
  context
}) => {
  const { params, history, ekycStatus, isFlowSuplesiActive } = context;
  const statusHandlers = {
    APP_EXPIRED: () => {
      history.push('/suplesi/home');
    },
    APP_CREATED: () => {
      dispatch(
        fetchLoanProduct(
          {
            ...auth,
            isSecondApply: data.isSecondApply
          },
          {
            action: () =>
              handleVerifyPayrollData(
                dispatch,
                auth,
                data,
                history,
                isFlowSuplesiActive
              )
          }
        )
      );
    },
    PAYROLL_APP: () => {
      handleVerifyPayrollData(
        dispatch,
        auth,
        data,
        history,
        isFlowSuplesiActive
      );
    },
    PAYROLL_REJ: () => {
      const nextEligibilityDate =
        data?.payrollrejdetails?.nextEligibilityDate || '';

      dispatch(setNextDate(nextEligibilityDate));
      params?.actionRejected?.(nextEligibilityDate);
    },
    CON_SAVED: () => {
      handleVerifyPayrollData(
        dispatch,
        auth,
        data,
        history,
        isFlowSuplesiActive
      );
    },
    CR_SCORE_SUB: () => {
      handleCreditScoreSubmission(dispatch, data, params, history);
    },
    CR_SCORE_REJ: () => {
      handleCreditScoreReject(dispatch, data, params, history);
    },
    CR_SCORE_APR: () => {
      handleCreditScoreApprove(dispatch, data, history);
    },
    USR_REJECT: () => {
      const nextEligibilityDate =
        data?.rejectionDetails?.nextEligibilityDate || '';

      dispatch(setNextDate(nextEligibilityDate));
      params?.actionRejected?.(nextEligibilityDate);
    },
    DISB_ACC_CONF: () => {
      if (ekycStatus === 'P') {
        dispatch(
          ekycCheckingStatusV3({ ...auth, applicationId: data.applicationId })
        );
      }
      history.push('/disburse-doc');
    },
    DOCUMENT_SIGN: () => {
      dispatch(
        checkValidatePhotoStatus(
          {
            phoneNo: auth.phoneNo,
            token: auth.token,
            applicationIdV3: data?.applicationIdSuplesi
          },
          data?.vidaESignDetail?.eSignId?.split('|'),
          {
            action: () =>
              dispatch(
                inquiryLoanPayment(auth, {
                  action: () => history.push('/suplesi/loan-payment')
                })
              ),
            loading: true
          },
          true
        )
      );
    },
    DOCUMENT_SIGNED: () => {
      dispatch(
        inquiryLoanPayment(auth, {
          action: () => {
            history.push('/suplesi/loan-payment');
          }
        })
      );
    },
    PAID_SUP_PROCESS: () => {
      history.push('/suplesi/paid-disb-process');
    },
    PAID_SUP_SUCCESS: () => {
      resetLocalStorageForPaidOffSuplesi();
      history.push('/suplesi/paid-disb-process');
    },
    PAID_SUP_FAILED: () => {
      resetLocalStorageForPaidOffSuplesi();
      dispatch(statusPayment('FAILURE'));
      dispatch(setIsFlowSuplesiActive(true));
      history.push('/repayment-message');
      return;
    }
  };

  dispatch(loading(false));
  dispatch(setIsFlowSuplesiActive(true));
  statusHandlers[appStatusSuplesi]?.();
};
